import './SyncAddAccountDialog.scss';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, RadioGroup } from '@mui/material';
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { getCalendarType, fields, getAccountType, StyledRadio, getEventsContent, isReAuthenticationReqd, shareEventsColumns, getErrorData, inputTextValidation } from './SyncToCalendarHelper';
import { useProfile } from '../../providers/Profile';
import { useAuthenticationContext } from '../../providers/AuthenticationProvider';
import { calendarType, findActiveAccounts, getCalendarName, notificationCodes, removeSpace, timeInterval } from '../SettingsSyncToCal/SettingsSyncToCalHelper';
import { useSettingsPageProvider } from '../../providers/SettingsProvider';
import AppleAuthenticator from './iOSAuthenticate';
import Loader from '../Loader/Loader';
import { useSyncToCalendarProvider } from '../../providers/SyncToCalendarProvider';

const SyncAddAccountDialog = ({ data, open, onClose, hideEditDialog, setHideEditDialog }) => {
  const { t } = useTranslation();
  const [pairingOverviewChecked, setPairingOverviewChecked] = useState(true);
  const [pairingBreakdownChecked, setPairingBreakdownChecked] = useState(true);
  const [checkedCustomPair, setCheckedCustomPair] = useState(false);
  const [radioBtnvalue, setRadioBtnValue] = useState('Personal Use');
  const [addInput, setAddInput] = useState('');
  const [customPairingInput, setAddCustomPairingInput] = useState('');
  const [nicknameErrorMsg, setNicknameErrorMsg] = useState({ validationError: false, maxLengthError: false, duplicateNameError: false });
  const [customPairingErrorMsg, setCustomPairingErrorMsg] = useState({ validationError: false, maxLengthError: false });
  const [showCustomPairing, setShowCutomPairing] = useState(false);
  const [shareEventsList, setShareEventsList] = useState<any>({});
  const [pairing, setPairing] = useState(data?.shareEventsCol?.pairings);
  const [active, setActive] = useState(true);  
  // const [googleEmailId, setGoogleEmailId] = useState('');
  const [emailId, setEmailId] = useState('');
  // const [googleEmailErrorMsg, setGoogleEmailErrorMsg] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState(false);
  const syncToCalendarContext = useSyncToCalendarProvider();
  const [hrefData, setHrefData] = useState("");
  const [iOSAuth, setiOSAuth] = useState(false);
  const [token, setToken] = useState(data?.token);
  const profileContext = useProfile();
  const profileData = profileContext?.profile?.results;
  const { signIn, authCode, isGoogleSigned, outlookSync, googleSignInFailResp, resetIsGoogleSigned, resetIsOutlookSigned } = useAuthenticationContext();
  const settingsContext = useSettingsPageProvider();
  const authRef = useRef(false);
  const manualSyncRef = useRef(false);
  const [isAccLimitExceeded, setIsAccLimitExceeded] = useState(false);
  const [notificationErrorMsg, setNotificationErrorMsg] = useState({ systemError: false, authenticateError: false, unAuthorizedError: false, duplicateEmailMsg : false });
  let accountNameRef = useRef(data?.accountNickNames || []);

  useEffect(() => {
    handleShowCutomPairing();
    generateShareEvents();
    handleShowApprovedBanner();

    // to check the body of the mail later 
    setHrefData(`mailto:myaccess@aircanada.ca?&subject=${!data?.dataFromEditPopUp?.errorCode? 'Invalid token' :'Sync to Calendar account unauthorized'} (error ${getErrorData(data?.dataFromEditPopUp?.errorCode)}) &body=Hello Team,%20%0D%0AName is ${profileData?.['name']} Emp id is ${profileData?.EmployeeId}, Base Location is ${profileData?.baseLocation} and Equipment is ${profileData?.equipment}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [radioBtnvalue, pairing, data.shareEventsCol]);


  useEffect(() => {
    if (data.operation !== 'edit' && data.operation === 'add') {
      const { emailId, modalFlag, availableEmailIds} = data;
        if(emailId && ((modalFlag.googleFlag && availableEmailIds['google'].includes(emailId.toLowerCase())) || 
            (modalFlag.iOSFlag && availableEmailIds['apple'].includes(emailId.toLowerCase())) || 
            (modalFlag.outlookFlag && availableEmailIds['outlook'].includes(emailId.toLowerCase())))){
              setNotificationErrorMsg({...notificationErrorMsg, duplicateEmailMsg : true});
        }
      return;
    }
    
    const editData = data?.dataFromEditPopUp;
    const email = editData?.emailId
    
    const accountName = editData[email]?.accountNickName;
    accountNameRef.current = data?.accountNickNames.filter(x => x !== accountName) || [];
    setAddInput(accountName);
    if (editData[email]?.enabled === true) setActive(true);
    else setActive(false);
    setCheckedCustomPair(editData[email]?.customFormat?.pairings?.selected);
    setAddCustomPairingInput(editData[email]?.customFormat?.pairings?.name);
    setPairingBreakdownChecked(editData[email]?.pairingBreakdown?.selected);
    setPairingOverviewChecked(editData[email]?.pairingOverview?.selected);

    if (editData[email]?.usage?.sharingwithFamily === true) setRadioBtnValue('Sharing with Family')
    else setRadioBtnValue('Personal Use')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.dataFromEditPopUp, data.operation])

  const handleCheckChange = (event) => {
    if (event.target.name === 'all') {
      reverseAll(event.target.checked);
    } else {
      if (data.shareEventsCol?.all === true) removeAll(event);
      else {
        data.setShareEventsCol({ ...data.shareEventsCol, [event.target.name]: event.target.checked });
      }
      if (event.target.name === 'pairings') {
        setPairing(event.target.checked);
        if(event.target.checked === false) {
          setPairingOverviewChecked(false);
          setPairingBreakdownChecked(false);
        } 
      }
    }
  }

  const checkPairingEventsSelected = () => {
    if(shareEventsList['pairings'] && shareEventsList['pairings']['selected']) {
      if(pairingBreakdownChecked || pairingOverviewChecked) {
        return false;
      }
      else {
        return true;
      }
    } else {
      return false;
    }
  }

  const addAll = () => {
    const eventsValueArray = Object.values(data.shareEventsCol);
    const count = eventsValueArray.filter(value => value === false).length;
    if (count === 1) { data.setShareEventsCol({ ...shareEventsColumns }) }
  }

  const removeAll = (event) => {
    data.setShareEventsCol({ ...data.shareEventsCol, [event.target.name]: event.target.checked, 'all': event.target.checked });
  }

  const generateShareEvents = () => {
    addAll();
    let tempObject = {} as any;
    for (const [key, value] of Object.entries(data.shareEventsCol)) {
      tempObject[key] = { selected: value }
    }
    setShareEventsList({ ...tempObject })
  };

  const reverseAll = (checkedValue) => {
    let tempObject = {};
    for (const key in data.shareEventsCol) {
      if (data.shareEventsCol.hasOwnProperty(key)) {
        if (key === 'pairings') {
          setPairing(checkedValue)
        }
        tempObject[key] = checkedValue;
      }
    }
    data.setShareEventsCol({ ...data.shareEventsCol, ...tempObject });
  }

  const handlePairingCheck = (event) => {
    if(event.target.name === t('myBlockMonth.syncToCalendar.pairingOverview')) {
      setPairingOverviewChecked((prev) => !prev);
    }

    if(event.target.name === t('myBlockMonth.syncToCalendar.pairingBreakdown')) {
      setPairingBreakdownChecked((prev) => !prev);
    }
  }

  const handleCustomPairingCheck = () => {
    setCheckedCustomPair((prev) => !prev);
    setAddCustomPairingInput('');
    setCustomPairingErrorMsg({ validationError: false, maxLengthError: false });
  }

  const handleRadioBtnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioBtnValue((event.target as HTMLInputElement).value);
    setAddCustomPairingInput('');
    setCustomPairingErrorMsg({ validationError: false, maxLengthError: false });
    setCheckedCustomPair(false);
  };

  const handleNickNameValidation = (e) => {
    const nickName = e?.target.value.trim();
    if (!inputTextValidation(e.target.value.trim()) && addInput.length !== 0) {
      setNicknameErrorMsg({ validationError: true, maxLengthError: false, duplicateNameError: false });
    } else if (e.target.value.length >= e.target.maxLength) {
      setNicknameErrorMsg({ validationError: false, maxLengthError: true, duplicateNameError: false });
    } else if (accountNameRef.current.includes(nickName)) setNicknameErrorMsg({ ...nicknameErrorMsg, duplicateNameError: true });
    else {
      setNicknameErrorMsg({ validationError: false, maxLengthError: false, duplicateNameError: false });
    }
  };

  const handleCalSyncToggle = () => {
    if (!settingsContext?.syncedCalendarData) return;
    const activeAccounts = findActiveAccounts(settingsContext?.syncedCalendarData);
    if (activeAccounts === 6 && !active) {
      setIsAccLimitExceeded(true);
    }
    else setActive(!active);
  }

  const handleShowCutomPairing = () => {
    if (radioBtnvalue === 'Sharing with Family' && pairing) setShowCutomPairing(true);
    else setShowCutomPairing(false);
  }

  const handleCustomPairingValidation = (e) => {
    if (!inputTextValidation(e.target.value.trim()) && customPairingInput.length !== 0) {
      setCustomPairingErrorMsg({ validationError: true, maxLengthError: false });
    } else if (e.target.value.length >= e.target.maxLength) {
      setCustomPairingErrorMsg({ validationError: false, maxLengthError: true });
    } else {
      setCustomPairingErrorMsg({ validationError: false, maxLengthError: false });
    }
  }

  const handleEmailValidation = (e) => {    
    const emailRegexPattern=/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    setEmailErrorMsg(emailId.length !== 0 && !emailRegexPattern.test(emailId));
    if((data?.modalFlag?.googleFlag && data?.availableEmailIds['google'].includes(e.target.value.toLowerCase())) || (data?.modalFlag?.outlookFlag && data?.availableEmailIds['outlook'].includes(e.target.value.toLowerCase()))) {
      setNotificationErrorMsg({...notificationErrorMsg, duplicateEmailMsg : true});
    } else {
      setNotificationErrorMsg({...notificationErrorMsg, duplicateEmailMsg : false});
    }
  }

  const getEmailAddress = () => {
    if (!data) return;
    if (data?.operation === 'add') {
      if (data?.enableEmailAddress) return emailId;
      else return data.emailId;
    }
    else {
      return data?.dataFromEditPopUp?.emailId;
    }
  }

  // Sync To Calendar Add Account btn for adding a account
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleAddAccountBtn = async () => {
    let syncToCal, emailObject, usageObj: any = {};

    usageObj = {
      personalUsage: radioBtnvalue === 'Personal Use',
      sharingwithFamily: radioBtnvalue === 'Sharing with Family'
    }
    emailObject = {
      enabled: (data.operation === 'add' ? true : active),
      accountNickName: addInput,
      usage: usageObj,
      events: shareEventsList,
      pairingBreakdown: {
        "selected": pairingBreakdownChecked
      },
      pairingOverview: {
        "selected": pairingOverviewChecked
      },
      customFormat: {
        "pairings": {
          "selected": checkedCustomPair,
          "name": removeSpace(customPairingInput)
        }
      }
    }
    
    syncToCal = {
      operation: data.operation,
      emailId: removeSpace(getEmailAddress()),
      accountType: (data.operation === 'add' ? getAccountType(data.modalFlag) : data?.dataFromEditPopUp?.accountType),
      token: token && token.length ? token : data?.token,
      screenName: "mbmcalendar",
      presetName: "displaypreferences",
      emailObject: emailObject,
    }
    
    manualSyncRef.current = true;
    try{
      if(syncToCal?.emailId && syncToCal?.emailId?.length) {
        await syncToCalendarContext.syncToCalendar(syncToCal);
      }
    }
    catch(error){
      console.warn('Error has occured while creating an account', error);
    }
  };

  const updateSuccessBanner = () => {
    data?.setSuccessMsgTimeOut(true);
    data?.setSuccessMsgDetails({
      emailId: getEmailAddress(),
      nickName: addInput
    })
    timeInterval(data?.setSuccessMsgTimeOut, data?.setSuccessMsgDetails);
  };

  useEffect(() => {
    const performManualSync = async () => {
      if (!data?.isSettingsScreen) updateSuccessBanner();
      const employeeID = profileData?.EmployeeId;
      await syncToCalendarContext.manualSyningData(employeeID);
      if (data?.isSettingsScreen) {
        await settingsContext.getSyncedCalendarData();
        updateSuccessBanner();
      }
    }

    if (!syncToCalendarContext?.syncToCalData) return;
    const response = syncToCalendarContext.syncToCalData;
    if (response.status && manualSyncRef.current) {
      const accountType = data.operation === 'add' ? getAccountType(data.modalFlag) : data?.dataFromEditPopUp?.accountType;
      accountType === 'outlook' &&  resetIsOutlookSigned();
      performManualSync();
      manualSyncRef.current = false;
      data.handleSuccessClose();
    }else if(parseInt(response?.errorCode) === 5008 && (response['errorMessage'] === t('myBlockMonth.syncToCalendar.invalidEmailErrorMessage') || response['errorMessage'] === t('myBlockMonth.syncToCalendar.newCodeErrorMessage') || response['errorMessage'] === t('myBlockMonth.syncToCalendar.timeOutErrorMessage')) && manualSyncRef.current){
      setHideEditDialog(true);
      manualSyncRef.current = false;
      data?.handleTokenError();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncToCalendarContext?.syncToCalData]);

  // Sync To Calendar Edit Account btn for editing an account
  const handleEditAccountBtn = async () => {
    await handleAddAccountBtn();
  }

  const OutlookSyncSuccess = (token) => {
    setToken(token);
  }

  const handleAccAuthentication = () => {
    const { accountType } = data?.dataFromEditPopUp;
    setiOSAuth(false);
    setHideEditDialog(true);
    switch (accountType) {
      case calendarType.OUTLOOK:
        //? updated auth code flow changes
        outlookSync(OutlookSyncSuccess);
        break;
      case calendarType.APPLE:
        window.open("https://appleid.apple.com");
        setiOSAuth(true);
        break;
      case calendarType.GOOGLE:
        authRef.current = true;
        signIn();
        break;
      default: return;

    }
  }

  useEffect(() => {
    if (isGoogleSigned && authRef.current) {
      authRef.current = false;
      setToken(authCode);
      resetIsGoogleSigned();
    }
    else if (!isGoogleSigned && googleSignInFailResp === 'access_denied' && authRef.current) {
      authRef.current = false;
      data?.handleSuccessClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGoogleSigned, authRef.current, googleSignInFailResp]);


  //? reauthentication flow starts here
  useEffect(() => {
    if (token !== data?.token) {
      handleAddAccountBtn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, data?.token]);

  const handleiOSAuthClose = useCallback(() => {
    setiOSAuth(false)
    data.handleSuccessClose();
  }, [setiOSAuth, data]);

  const handleiOSAuthSuccess = useCallback((appleEmail, applePwd) => {
    setToken(applePwd);
    setiOSAuth(false);
  }, [setiOSAuth]);

  const resetFields = useCallback(() => {
    if (data.confirmCloseModal) {
      setAddInput('');
      setNicknameErrorMsg({ validationError: false, maxLengthError: false, duplicateNameError: false });
      setAddCustomPairingInput('');
      setCustomPairingErrorMsg({ validationError: false, maxLengthError: false });
      setEmailId('');
      setEmailErrorMsg(false);
      setRadioBtnValue('Personal Use');
      setPairingBreakdownChecked(false);
      setPairingOverviewChecked(false);
      setCheckedCustomPair(false);
    }
    else return;
  }, [data.confirmCloseModal])

  useEffect(() => {
    resetFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFields])

  const handleDialogClose = (event, reason) => {
    reason !== 'backdropClick' && onClose();
  }

  const handleShowApprovedBanner = () => {
    const errorCode = parseInt(data?.dataFromEditPopUp?.errorCode);
    switch (errorCode) {
      case notificationCodes.SYSTEMERROR:
        setNotificationErrorMsg({ ...notificationErrorMsg,  systemError: true, authenticateError: false, unAuthorizedError: false });
        break;
      case notificationCodes.AUTHENTICATEERROR:
        setNotificationErrorMsg({ ...notificationErrorMsg, systemError: false, authenticateError: true, unAuthorizedError: false });
        break;
      case notificationCodes.UNAUTHORIZEERROR:
        setNotificationErrorMsg({ ...notificationErrorMsg, systemError: false, authenticateError: false, unAuthorizedError: true });
        break;
      default:
        break;
    }
  }

  return syncToCalendarContext.syncCalendarLoading || syncToCalendarContext.manualSyncLoading ? <Loader /> : (
    <>
      {iOSAuth && <AppleAuthenticator open={iOSAuth} onClose={handleiOSAuthClose} onAuthSuccess={handleiOSAuthSuccess} availableEmailIds={data?.availableEmailIds} linkedEmail={getEmailAddress()}/>}
      {!hideEditDialog && <Dialog
        open={open}
        onClose={handleDialogClose}
        className='sync-add-account__dialog'
        maxWidth='lg'
        disableEscapeKeyDown={true}
      >
        <div className='sync-add-account__dialog-header'>
          <IconButton
            aria-label='close'
            onClick={() => data.handleAction()}
            className='sync-add-account__dialog-close-btn'
            size="large">
            <CloseIcon fontSize='large' />
          </IconButton>
        </div>

        <DialogTitle>
          <div>
            <h3 className="sync-add-account__title">{data.operation === 'add' ? t('myBlockMonth.syncToCalendar.addAccount') : data.operation === 'edit' ? t('myBlockMonth.syncToCalendar.editAccount') : ''}</h3>
          </div>
        </DialogTitle>

        <DialogContent className='sync-add-account__dialog-content'>

          {/* Start -- Error Messages to be displayed at the top as red banners for the Edit and Add Modals */}

          {notificationErrorMsg.authenticateError && <div className='sync-add-account__error-notification sync-add-account__sync-notification'>
            <i className='icon-Error-warning' /><p>{t('settingsScreen.editAuthenticate')}</p>
          </div>}

          {notificationErrorMsg.systemError && <div className='sync-add-account__error-notification sync-add-account__sync-notification'>
            <i className='icon-Error-warning' /><p>{t('settingsScreen.editSystemError')}</p>
          </div>}

          {isAccLimitExceeded && <div className='sync-add-account__error-notification sync-add-account__sync-notification'>
            <i className='icon-Error-warning' /><p>{t('settingsScreen.editAccountLimitError')}</p>
          </div>}

          {notificationErrorMsg.unAuthorizedError &&
            <div className='sync-add-account__error-notification sync-add-account__sync-notification'><i className='icon-Error-warning' />
              <p className='sync-add-account__system-error' title="myaccess@aircanada.ca">{t('settingsScreen.editUnAuthorizedText1')}&nbsp;</p>
              <span><a className='sync-add-account__system-error-content' href={hrefData}>{t('settingsScreen.supportLink')}</a></span>&nbsp;{t('settingsScreen.forAssistance')}
            </div>
          }

          {notificationErrorMsg.duplicateEmailMsg && <div className='sync-add-account__error-notification sync-add-account__sync-notification'>
            <i className='icon-Error-warning' /><p>{t('settingsScreen.duplicateEmailErrorMsg')}</p>
          </div>}
          {/* End -- Error Messages to be displayed */}

          <div className='sync-add-account__cntr-content-one'>
            <div className='sync-add-account__cntr-email'>
              <p className='sync-add-account__cntr-email-label'>{t('myBlockMonth.syncToCalendar.emailAddress')}</p>
              {data.enableEmailAddress && data.operation === 'add' ?
                <>
                  <input type="email"
                    placeholder="ie. emily.snow@gmail.com"
                    className={emailErrorMsg ? 'sync-add-account__cntr-input-text sync-add-account__cntr-text-error'
                      : 'sync-add-account__cntr-input-text'} value={emailId}
                    onChange={(e) => setEmailId(e.target.value)} onBlur={(e) => handleEmailValidation(e)} />
                  <div id="sync-add-account__text-error" className="sync-add-account__text-error">
                    {emailErrorMsg && <><i className='icon-circle-flight' /><span>{t('myBlockMonth.syncToCalendar.gmailError')}</span></>}
                  </div>
                </>
                :
                <p className='sync-add-account__cntr--longer-email'>{data.operation === 'add' ? data?.emailId : data?.dataFromEditPopUp?.emailId}</p>
              }
            </div>
            <div className='sync-add-account__cntr-type'>
              <p className='sync-add-account__cntr-type-label'>{t('myBlockMonth.syncToCalendar.calendarType')}</p>
              <p className='sync-add-account__cntr-type-text'>{data.operation === 'add' ? t(getCalendarType(data?.modalFlag)) : t(getCalendarName(data?.dataFromEditPopUp?.accountType))}</p>
            </div>
            {data.operation === 'edit' ?
              <div className='sync-add-account__cntr-sync'>
                <p className='sync-add-account__cntr-sync-label'>{t('myBlockMonth.syncToCalendar.calendarSync')}</p>
                <div className='sync-add-account__cntr-sync-btn '>
                  <label className="sync-add-account__cntr-sync-switch">
                    <input type="checkbox" id="togBtn" checked={active} onChange={() => handleCalSyncToggle()} />
                    <div className="sync-add-account__cntr-sync-switch-slider"></div>
                  </label>
                </div>
              </div>
              : ''}
          </div>

          <div className='sync-add-account__cntr-content-two'>
            <div className='sync-add-account__cntr-nickname'>
              <p className='sync-add-account__cntr-nickname-label'>{t('myBlockMonth.syncToCalendar.accountNickname')}</p>
              <input type="text"
                placeholder="ie. Family Calendar"
                className={nicknameErrorMsg?.maxLengthError || nicknameErrorMsg?.validationError || nicknameErrorMsg.duplicateNameError ?
                  'sync-add-account__cntr-input-text sync-add-account__cntr-text-error' : 'sync-add-account__cntr-input-text'}
                value={addInput} onChange={(e) => setAddInput(e.target.value)} onKeyUp={(e) => handleNickNameValidation(e)} minLength={0} maxLength={31} />
              <div id="sync-add-account__text-error" className="sync-add-account__text-error">
                {nicknameErrorMsg?.validationError && <><i className='icon-circle-flight' /><span>{t('myBlockMonth.syncToCalendar.textErrorMsg')}</span></>}
                {nicknameErrorMsg?.maxLengthError && <><i className='icon-circle-flight' /><span>{t('myBlockMonth.syncToCalendar.maximumerror')}</span></>}
                {nicknameErrorMsg?.duplicateNameError && <><i className='icon-circle-flight' /><span>{t('myBlockMonth.syncToCalendar.nickNameExistErrorMsg')}</span></>}
              </div>
              {!nicknameErrorMsg?.validationError && !nicknameErrorMsg?.maxLengthError ? <p className='sync-add-account__cntr-nickname-input-characters'>{`${addInput?.length}${"/30 characters"}`}</p> : ''}
            </div>

            <div className='sync-add-account__cntr-usage'>
              <p className='sync-add-account__cntr-usage-label'>{t('myBlockMonth.syncToCalendar.usage')}</p>
              <FormControl>
                <RadioGroup row name={t('myBlockMonth.syncToCalendar.usage')} value={radioBtnvalue} onChange={handleRadioBtnChange}>
                  <div className="sync-add-account__cntr-usage-radio-option">
                    <FormControlLabel value="Personal Use" control={<StyledRadio />} label={t('myBlockMonth.syncToCalendar.personalUse')} labelPlacement="end" />
                  </div>
                  <div className="sync-add-account__cntr-usage-radio-option sync-add-account__cntr-usage-padding-label">
                    <FormControlLabel value="Sharing with Family" control={<StyledRadio />} label={t('myBlockMonth.syncToCalendar.sharingWithFamily')} labelPlacement="end" />
                  </div>
                </RadioGroup>
              </FormControl>
            </div>
          </div>


          <div className='sync-add-account__share-events-main-cntr'>
            <div className='sync-add-account__share-events-cntr'>
              <span className='sync-add-account__share-events-title'>{t('myBlockMonth.syncToCalendar.shareEvents')}</span>
              <span className='sync-add-account__share-events-select-title'>{t('myBlockMonth.syncToCalendar.selectEventShare')}</span>
            </div>

            <div className='sync-add-account__share-events-columns-list'>
              {fields.map((option, index) =>
                <FormControlLabel
                  key={index}
                  control={<Checkbox className='styledCheckBox' checked={data.shareEventsCol[option.field]}
                    icon={<CheckBoxOutlineBlankSharpIcon className='check-box-icon-outline' />}
                    checkedIcon={<CheckBoxSharpIcon className='check-box-con-solid' />}
                    onChange={handleCheckChange} name={option.field} disableRipple />}
                  label={option.headerName}
                />
              )}
            </div>

            {pairing && <div className='sync-add-account__pairing-format-cntr'>
              <span className='sync-add-account__pairing-format-title'>{t('myBlockMonth.syncToCalendar.pairingFormat')}</span>
              <FormControlLabel
                control={
                  <Checkbox className='styledCheckBox' checked={pairingOverviewChecked} onChange={(event) => handlePairingCheck(event)}
                    icon={<CheckBoxOutlineBlankSharpIcon className='check-box-icon-outline' />}
                    checkedIcon={<CheckBoxSharpIcon className='check-box-con-solid' />} disableRipple name={t('myBlockMonth.syncToCalendar.pairingOverview')} />
                }
                label={t('myBlockMonth.syncToCalendar.pairingOverview')}
              />
              <FormControlLabel
                control={
                  <Checkbox className='styledCheckBox' checked={pairingBreakdownChecked} onChange={(event) => handlePairingCheck(event)}
                    icon={<CheckBoxOutlineBlankSharpIcon className='check-box-icon-outline' />}
                    checkedIcon={<CheckBoxSharpIcon className='check-box-con-solid' />} disableRipple name={t('myBlockMonth.syncToCalendar.pairingBreakdown')} />
                }
                label={t('myBlockMonth.syncToCalendar.pairingBreakdown')}
              />
              {showCustomPairing ?
                <>
                  <div className='sync-add-account__customized-pairing-cntr'>
                    <FormControlLabel
                      control={
                        <Checkbox className='styledCheckBox' checked={checkedCustomPair} onChange={() => handleCustomPairingCheck()}
                          icon={<CheckBoxOutlineBlankSharpIcon className='check-box-icon-outline' />}
                          checkedIcon={<CheckBoxSharpIcon className='check-box-con-solid' />} disableRipple name='customizedPairingNames-checkbox' />
                      }
                      label={t('myBlockMonth.syncToCalendar.customizedPairingNames')}
                    />
                    <input type="text"
                      placeholder="ie. John's Flying"
                      className={customPairingErrorMsg?.maxLengthError || customPairingErrorMsg?.validationError ?
                        'sync-add-account__customized-pairing-text-error sync-add-account__customized-pairing-input-text' : 'sync-add-account__customized-pairing-input-text'}
                      onChange={(e) => setAddCustomPairingInput(e.target.value)} value={customPairingInput}
                      onKeyUp={(e) => handleCustomPairingValidation(e)} minLength={0} maxLength={31} disabled={!checkedCustomPair}
                    />
                  </div>
                  <div className="sync-add-account__text-error sync-add-account__custom-text-error">
                    {customPairingErrorMsg?.validationError && <><i className='icon-circle-flight' /><span>{t('myBlockMonth.syncToCalendar.textErrorMsg')}</span></>}
                    {customPairingErrorMsg?.maxLengthError && <><i className='icon-circle-flight' /><span>{t('myBlockMonth.syncToCalendar.maximumerror')}</span></>}
                  </div>
                  {!customPairingErrorMsg?.validationError && !customPairingErrorMsg?.maxLengthError ? <p className='sync-add-account__customized-pairing-input-characters'>{`${customPairingInput?.length}${"/30 characters"}`}</p> : ''}
                </>
                : ''
              }
            </div>}
          </div>
        </DialogContent>

        <DialogActions>
          <div className="sync-add-account__buttons">
            {(data.thirdActionLabel) && <Button style={{ marginRight: isReAuthenticationReqd(data?.dataFromEditPopUp) ? '16rem' : '22.3rem' }} className='btn-white' onClick={() => data.handleThirdAction()}><span>{data.thirdActionLabel}</span></Button>}
            {(data.actionLabel) && <Button className='btn-white' onClick={() => {
              data.handleAction();
              resetFields();
            }}><span>{data.actionLabel}</span></Button>}
            {data.secondaryActionLabel && !isReAuthenticationReqd(data?.dataFromEditPopUp) &&
              <Button
                disabled={
                  customPairingErrorMsg?.maxLengthError 
                  || customPairingErrorMsg?.validationError
                  || nicknameErrorMsg?.maxLengthError 
                  || nicknameErrorMsg?.validationError 
                  || nicknameErrorMsg?.duplicateNameError
                  || (data?.operation === 'add' ? data?.enableEmailAddress ? !emailId : !data?.emailId : !data?.dataFromEditPopUp?.emailId)
                  || !addInput 
                  || getEventsContent(data?.shareEventsCol) 
                  || notificationErrorMsg.duplicateEmailMsg 
                  || (checkedCustomPair && !customPairingInput) 
                  || emailErrorMsg
                  || checkPairingEventsSelected()
                }
                className='btn-black' style={{ marginRight: '1.2rem' }} onClick={() => (data?.operation === 'add' ? handleAddAccountBtn() : handleEditAccountBtn())}>​​​ 
                <span>{data.secondaryActionLabel}</span>
              </Button>}
            {isReAuthenticationReqd(data?.dataFromEditPopUp) &&
              <Button
                disabled={
                  customPairingErrorMsg?.maxLengthError 
                  || customPairingErrorMsg?.validationError
                  || nicknameErrorMsg?.maxLengthError 
                  || nicknameErrorMsg?.validationError 
                  || nicknameErrorMsg?.duplicateNameError
                  || (!data?.dataFromEditPopUp?.emailId)
                  || !addInput 
                  || getEventsContent(data?.shareEventsCol)
                }
                className='btn-black btn-black__authenticate' style={{ marginRight: '1.2rem' }} onClick={() => handleAccAuthentication()}>​​​ 
                <span>{t('myBlockMonth.syncToCalendar.btnLabelAuthenticate')}</span>
              </Button>}
          </div>
        </DialogActions>
      </Dialog>}
    </>
  );
};

export default SyncAddAccountDialog;
